import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useOption } from '@react-aria/listbox';
import classNames from 'classnames';
import { CheckIcon } from '../../components';
import styles from './Dropdown.module.scss';
const DropdownOption = ({ state, node, showCheckIcon, item, className, index, }) => {
    const ref = useRef(null);
    const isDisabled = state.disabledKeys.has(node.key);
    const isSelected = state.selectionManager.isSelected(node.key);
    const { optionProps } = useOption({
        key: node.key,
        isDisabled,
        isSelected,
        shouldSelectOnPressUp: true,
        shouldFocusOnHover: true,
    }, state, ref);
    const idToPreventRandomId = `${item.label}-${index}`;
    return (_jsxs("li", { ...optionProps, ref: ref, className: classNames('d-flex align-items-center', styles.option, styles.isFocused, className, {
            'fw-semibold': isSelected,
        }), "data-testid": idToPreventRandomId, children: [item.label, isSelected && showCheckIcon && _jsx(CheckIcon, {})] }));
};
export { DropdownOption };
